<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">ข้อมูล Device</span>
      <v-scroll-x-transition>
        <div style="display: flex" v-show="!formShow">
          <v-text-field
            v-model="search"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            solo
            dense
            hide-details
            style="width: 200px; padding: 0 5px"
          ></v-text-field>
        </div>
      </v-scroll-x-transition>
    </div>
    <!-- <v-toolbar flat color="blue-grey lighten-4">
      <span class="font-weight-medium">ข้อมูล Device</span>
      <v-scroll-x-transition>
        <v-row align="center" v-show="!formShow">
          <v-spacer></v-spacer>
          <v-col md="3" lg="3" xl="2">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              clearable
              flat
              solo
              dense
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-scroll-x-transition>
    </v-toolbar> -->
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="hardwares"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
    </v-data-table>
    <HardwareForm
      :formShow="formShow"
      :formAction="formAction"
      :hardware="hardware"
      :hardwareInit="hardwareInit"
      @isHardwareDataChange="handleHardwareFormDataChange"
      @formActionCompleted="handleHardwareFormActionCompleted"
      @onReset="handleHardwareFormReset"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import HardwareForm from '@/views/hardware/HardwareForm.vue'

export default {
  components: {
    HardwareForm,
    ConfirmDialog,
  },
  data() {
    return {
      sortBy: ['hardware_serial_number'],
      sortDesc: [false],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: true,
      search: '',
      formShow: false,
      formAction: '',
      hardware: {},
      hardwareInit: {},
      isHardwareDataChange: false,
      timeout: null,
      headers: [
        { text: 'Serial Number', value: 'hardware_serial_number' },
        { text: 'รหัส Device', value: 'hardware_code' },
        { text: 'ชื่อ Device', value: 'title_th' },
        { text: 'ชื่อ Device (อังกฤษ)', value: 'title_en' },
        { text: 'ชื่อรุ่น Device', value: 'hardware_model.title' },
        { text: 'สถานะ Device', value: 'hardware_status.title_th' },
      ],
    }
  },
  computed: {
    hardwares() {
      return this.$store.state.hardware.hardwares
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'ข้อมูล Device',
        disabled: true,
      },
    ])

    this.loadData()
  },
  methods: {
    ...mapActions({
      fetchHardwares: 'hardware/fetchHardwares',
      getNetworkConfig: 'hardware/getNetworkConfig',
    }),
    classRowSelected(row) {
      if (this.hardware.hardware_uuid === row.hardware_uuid)
        return 'row-selected'
    },
    setDataRowSelected(row) {
      if (this.hardware.hardware_uuid === row.hardware_uuid) {
        this.formShow = false
        this.formAction = ''
        this.hardware = {}
        this.hardwareInit = {}
      } else {
        const { company_uuid } = this.$store.state.authentication.company

        if (
          row.hardware_model &&
          (row.hardware_model.hardware_model_code === 'vf1000' ||
            row.hardware_model.hardware_model_code === 'vf1000r' ||
            row.hardware_model.hardware_model_code === 'acu01r' ||
            row.hardware_model.hardware_model_code === 'vf600')
        ) {
          this.$store.state.loading = true
          const payload = {
            company_uuid,
            hardware_model: row.hardware_model.hardware_model_code,
            body: {
              hardware_uuid: row.hardware_uuid,
            },
          }
          this.getNetworkConfig(payload)
            .then(({ network }) => {
              this.$store.state.loading = false

              this.formShow = true
              this.formAction = 'edit'
              this.hardware = {
                ...row,
                hardware_model_title: row.hardware_model
                  ? row.hardware_model.title
                  : '',
                hardware_status_title: row.hardware_status
                  ? row.hardware_status.title_th
                  : '',
                network: { ...network } || {},
              }
              this.hardwareInit = {
                ...row,
                hardware_model_title: row.hardware_model
                  ? row.hardware_model.title
                  : '',
                hardware_status_title: row.hardware_status
                  ? row.hardware_status.title_th
                  : '',
                network: { ...network } || {},
              }
            })
            .catch((error) => {
              this.$store.state.loading = false
            })
        } else {
          this.formShow = true
          this.formAction = 'edit'
          this.hardware = {
            ...row,
            hardware_model_title: row.hardware_model
              ? row.hardware_model.title
              : '',
            hardware_status_title: row.hardware_status
              ? row.hardware_status.title_th
              : '',
          }
          this.hardwareInit = {
            ...row,
            hardware_model_title: row.hardware_model
              ? row.hardware_model.title
              : '',
            hardware_status_title: row.hardware_status
              ? row.hardware_status.title_th
              : '',
          }
        }
      }
    },
    handleRowSelected(row) {
      if (this.isHardwareDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleHardwareFormDataChange(value) {
      this.isHardwareDataChange = value
    },
    handleHardwareFormReset() {
      if (
        this.hardware.hardware_model &&
        (this.hardware.hardware_model.hardware_model_code === 'vf1000' ||
          this.hardware.hardware_model.hardware_model_code === 'vf1000r' ||
          this.hardware.hardware_model.hardware_model_code === 'acu01r' ||
          this.hardware.hardware_model.hardware_model_code === 'vf600')
      ) {
        this.hardware = {
          ...this.hardwareInit,
          network: { ...this.hardwareInit.network },
        }
      } else {
        this.hardware = { ...this.hardwareInit }
      }
    },
    handleHardwareFormActionCompleted(formAction) {
      if (formAction === 'edit') {
        this.hardware = {}
        this.hardwareInit = {}
      }
      this.formShow = false
      this.formAction = ''
    },
    loadData() {
      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        params: { company_uuid },
      }
      this.fetchHardwares(payload)
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.formShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isHardwareDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
